import Link from './Link';

export const models = {
    Link,
};
